import type RtpState from './RtpState';

const getRtpStateBackground = (state: RtpState) => {
  switch (state) {
    case 'hot':
      return 'bg-chichi';
    case 'cold':
      return 'bg-whis';
    case 'neutral':
      return 'bg-goku';
    default:
      return undefined;
  }
};

export default getRtpStateBackground;
